__turbopack_context__.v({
  "chip": "FeatureGateLabel-module__CYgYvG__chip",
});
